import {register} from '@shopify/theme-sections';
import Flickity from 'flickity';
import 'flickity-imagesloaded';


import '../components/img-comparison-slider';

register('before-after', {
  onLoad() {
    const sliderContainer = this.container.querySelector('[data-comparison]');
    const disclaimerContainer = this.container.querySelector('[data-disclaimers]');
    const thumbnails = this.container.querySelectorAll('[data-thumbnail]');
    const classes = {
      previous: 'before-after__thumbnails-button--previous',
      next: 'before-after__thumbnails-button--next',
      inactive: 'before-after__thumbnails-button--inactive'
    };

    let disclaimerSlider;

    if (disclaimerContainer) {
       disclaimerSlider = new Flickity(disclaimerContainer, {
        draggable: false,
        prevNextButtons: false,
        pageDots: false,
        wrapAround: true,
      });
    }

    if(!sliderContainer) return;

    const slider = new Flickity(sliderContainer, {
      draggable: false,
      prevNextButtons: false,
      pageDots: false,
      imagesLoaded: true,
      wrapAround: true
    });

    slider.on('change', (index) => {
      if (disclaimerSlider) {
        disclaimerSlider.selectCell(index);
      }

      // Update thumbnail classes
      thumbnails.forEach((thumbnail, thumbnailIndex) => {
        // Remove classes
        thumbnail.classList.remove(classes.previous);
        thumbnail.classList.remove(classes.next);
        thumbnail.classList.remove(classes.inactive);

        // Get previous and next index
        const previousIndex = index === 0 ? thumbnails.length - 1 : index - 1;
        const nextIndex = index === thumbnails.length - 1 ? 0 : index + 1;

        // Add classes based on index
        if(thumbnailIndex === previousIndex) {
          thumbnail.classList.add(classes.previous);
        } else if (thumbnailIndex === nextIndex) {
          thumbnail.classList.add(classes.next);
        } else {
          thumbnail.classList.add(classes.inactive);
        }
      });
    });

    thumbnails.forEach((thumbnail, index) => {
      thumbnail.addEventListener('click', event => {
        event.preventDefault();
        slider.selectCell(index);
      })
    });
  },
});
